import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-611ce75d"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "card card-sub"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-body text-center text-danger py-3" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fas fa-exclamation-triangle me-2" }),
  /*#__PURE__*/_createTextVNode("ไม่พบข้อมูล ")
], -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = {
  key: 1,
  class: "table-responsive"
}
const _hoisted_5 = { class: "table table-hover" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "#"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "โครงการ"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "งบที่ได้รับ"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "งบที่ใช้จริง"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "เบิกจ่าย/ส่งคืน"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "สถานะ")
  ])
], -1))
const _hoisted_7 = ["onClick"]
const _hoisted_8 = ["data-bs-content"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-cube me-2" }, null, -1))
const _hoisted_10 = { class: "text-end" }
const _hoisted_11 = { class: "text-end" }
const _hoisted_12 = { class: "text-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_dompurify_html = _resolveDirective("dompurify-html")!

  return (_ctx.projects.length === 0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
    : (_openBlock(), _createElementBlock("div", _hoisted_4, [
        _createElementVNode("table", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.projects, (project, index) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: index,
                class: "row-hover",
                onClick: ($event: any) => (_ctx.selectedClick(project.id))
              }, [
                _createElementVNode("td", null, _toDisplayString(index + 1), 1),
                _createElementVNode("td", {
                  class: "column-name text-truncate",
                  "data-bs-toggle": "popover-done",
                  "data-bs-content": project.name
                }, [
                  _hoisted_9,
                  _createTextVNode(_toDisplayString(project.name), 1)
                ], 8, _hoisted_8),
                _createElementVNode("td", _hoisted_10, _toDisplayString(Number(project.projectBudgets.filter(m => m.id !== 4).reduce((total, m) => total + m.amount, 0)).toLocaleString('en', { minimumFractionDigits: 2, maximumFractionDigits: 2 })), 1),
                _withDirectives(_createElementVNode("td", _hoisted_11, null, 512), [
                  [_directive_dompurify_html, (project.projectStatus.key > 1) ? Number(project.projectResult.realBudget).toLocaleString('en', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '-']
                ]),
                _withDirectives(_createElementVNode("td", _hoisted_12, null, 512), [
                  [_directive_dompurify_html, (project.projectStatus.key > 1) ? Number(project.projectResult.totalSpent).toLocaleString('en', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '-']
                ]),
                _createElementVNode("td", null, [
                  _createElementVNode("span", {
                    style: _normalizeStyle({ color: project.projectStatus.color })
                  }, _toDisplayString(project.projectStatus.name), 5)
                ])
              ], 8, _hoisted_7))
            }), 128))
          ])
        ])
      ]))
}